/* eslint react/no-did-mount-set-state: 0 */
import React, { PureComponent } from "react";
import styled from "styled-components";
import Movie from "./Movie";
import { getMovies } from '../utils/api';

class MoviesList extends PureComponent {
  state = {
    movies: []
  };

  componentDidMount() {
    getMovies().then((movies) => {
      this.setState({
        movies
      });
    });  
  }

  render() {
    const { movies } = this.state;
    
    return (
      <MoviesWrapper>
        <PageTitle>
          <h1>Playing Now</h1>
        </PageTitle>
        <MovieGrid>
          {movies.map(movie => (
            <Movie key={movie.id} movie={movie} />
          ))}
        </MovieGrid>
      </MoviesWrapper>
    );
  }
}

export default MoviesList;

const MoviesWrapper = styled.div`
  width: 95%;
  margin: 0 auto;
`;
const PageTitle = styled.div`
  margin: 10px 2rem 5px;
  border-bottom: 2px solid #00fc87;
  h1 {
    margin-bottom: 0.2em;
  }
`;
const MovieGrid = styled.div`
  display: grid;
  padding: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 1.2rem 1.5rem;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/component/MoviesList.js